import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabActive: 0,
    tabs: [
      {
        sysPermissionId: 0,
        sysPermissionName: "公司信息",
        sysPermissionUrl: "/Company/List",
      }
    ]
  },
  getters: {
  },
  mutations: {
    addTab(state, tab) {
      state.tabs.push(tab);
      state.tabActive = tab.sysPermissionId;
    }
  },
  actions: {
  },
  modules: {
  }
})
